module.exports = __webpack_public_path__ + "static/media/rank1.7903b6ec.png";